<template>
  <div class="flex flex-col gap-4">
    <div class="text-lg font-medium mb-2">Click Tracking Analytics</div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <!-- Users List -->
      <div class="flex flex-col gap-4">
        <div class="font-medium">Users</div>
        <UsersList
          :users="users"
          :is-loading-users="isLoadingUsers"
          :has-more-users="hasMoreUsers"
          @load-more="loadMoreUsers"
        />
      </div>

      <!-- Sessions List -->
      <div v-if="selectedUserId" class="flex flex-col gap-4">
        <div class="font-medium">Sessions</div>
        <UserSessions
          :sessions="sessions"
          :is-loading-sessions="isLoadingSessions"
          :has-more-sessions="hasMoreSessions"
          @load-more="loadMoreSessions"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, watch } from "vue";
import { useAnalytics } from "@/stores";
import UsersList from "./UsersList.vue";
import UserSessions from "./UserSessions.vue";

const analyticsStore = useAnalytics();

// Computed properties
const users = computed(() => analyticsStore.users);
const sessions = computed(() => analyticsStore.sessions);
const selectedUserId = computed(() => analyticsStore.selectedUserId);
const isLoadingUsers = computed(() => analyticsStore.isLoadingUsers);
const isLoadingSessions = computed(() => analyticsStore.isLoadingSessions);
const hasMoreUsers = computed(() => analyticsStore.hasMoreUsers);
const hasMoreSessions = computed(() => analyticsStore.hasMoreSessions);

// Methods
const loadMoreUsers = async () => {
  await analyticsStore.fetchClickUsers(true);
};

const loadMoreSessions = async () => {
  if (selectedUserId.value) {
    await analyticsStore.fetchUserSessions(selectedUserId.value, true);
  }
};

// Props
const props = defineProps({
  isVisible: {
    type: Boolean,
    required: true,
  },
});

// Load data when component becomes visible
watch(
  () => props.isVisible,
  async (isVisible) => {
    if (isVisible) {
      await analyticsStore.fetchClickUsers();
    }
  },
  { immediate: true }
);
</script>
